import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService, SortEvent } from 'primeng/api';

import { ActivatedRoute, Router } from '@angular/router';
import { PessoaService } from '../../../../services/pessoas/pessoas.service';
import { PessoaDTO } from '../../../../models/clientes/pessoa.model';
import { NotaService } from '../../../../services/financeiro/notas.service';
import { NotaDTO } from '../../../../models/nota.model';

@Component({
  selector: 'app-lista-de-clientes-view.component',
  templateUrl: './lista-de-clientes-view.component.html',
  styleUrls: ['./lista-de-clientes-view.component.scss'],
  providers: [ConfirmationService, MessageService],
})
export class ListadeClientesViewComponent implements OnInit {
  clienteID = -1;

  constructor(private router: Router, private route: ActivatedRoute) {}

  async ngOnInit() {
    this.clienteID = Number(this.route.snapshot.paramMap.get('id'));

    if (!this.clienteID || this.clienteID <= 0) {
      this.router.navigate(['/lista-de-clientes']);
      return;
    }
  }
}
